// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-11b5f477]{width:100%;display:flex;justify-content:center;margin-top:50px}", ""]);
// Exports
module.exports = exports;
